"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XS_OUTER_PADDING = exports.XS_IMAGE_SIZE = exports.XS_COLUMN_GAP = exports.SM_OUTER_PADDING = exports.SM_IMAGE_SIZE = exports.SM_COLUMN_GAP = exports.SMALL_SECTION_WIDTH = exports.MD_OUTER_PADDING = exports.MD_IMAGE_SIZE = exports.MD_COLUMN_GAP = void 0;
const SMALL_SECTION_WIDTH = exports.SMALL_SECTION_WIDTH = 600;
const XS_IMAGE_SIZE = exports.XS_IMAGE_SIZE = 120;
const XS_COLUMN_GAP = exports.XS_COLUMN_GAP = 10;
const XS_OUTER_PADDING = exports.XS_OUTER_PADDING = 15;
const SM_IMAGE_SIZE = exports.SM_IMAGE_SIZE = 120;
const SM_COLUMN_GAP = exports.SM_COLUMN_GAP = 10;
const SM_OUTER_PADDING = exports.SM_OUTER_PADDING = 30;
const MD_IMAGE_SIZE = exports.MD_IMAGE_SIZE = 150;
const MD_COLUMN_GAP = exports.MD_COLUMN_GAP = 15;
const MD_OUTER_PADDING = exports.MD_OUTER_PADDING = 30;
